import React from "react";
import { topSectionData, footerSection, NavSection } from "./HeaderAndFooter";
import { Helmet } from "react-helmet";
import { Fade, Zoom, } from 'react-reveal';
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader

const contentSection = (
  <>
    <div class='dispfbanner'>
      <div class='bannerarea'>
        <h4 data-aos='zoom-in-down'>PLAY OR LEARN</h4>
        <h1 data-aos='fade-up'>
          Futsal (Mini-Football) -  Best Infrastructure. Professional Coaching.
        </h1>
        <div class='btarea' data-aos='zoom-in'></div>
      </div>
    </div>
    <div class='aboutarea ' data-aos='zoom-in'>
      <div class='aboutbox '>
        <div class='boxes '>
          <svg>
            <use href='#park'></use>
          </svg>
          <h5> 5 Cities</h5>
        </div>
        <div class='boxes '>
          <svg viewBox='0 0 55.558 47.814'>
            <use href='#stadium'></use>
          </svg>
          <h5> Best in Class Infra</h5>
        </div>
        <div class='boxes '>
          <svg>
            <use href='#football'></use>
          </svg>
          <h5> FIFA certified Turfs </h5>
        </div>
      </div>
    </div>
  </>
);
const futsalVenueList = [
  {
    companyName: "PlayAll",
    venueName: "PlayAll SRM Noida 33",
    numberOfCourts: 1,
    courtType: "6-Vs-6", 
    city: "Noida",
    address: "B-67, near NTPC Township, Sector 33, Noida, Uttar Pradesh,- 201303 | Contact - 011-408-47233",
    googleMapLink: "https://maps.app.goo.gl/5NXtvWyyqYZkVwuc6",
    images: [
      "https://d21gjxs9m3o5hx.cloudfront.net/uploadvenueimages/1748864777703-filename0.jpg"
       ]
  },
  {
    companyName: "PlayAll",
    venueName: "PlayAll MGR Mogappair East",
    numberOfCourts: 3,
    courtType: "6-Vs-6", 
    city: "Chennai",
    address: "Veeramamunivar St, Block 12, Block 11, J J Nagar, Anna Nagar, Chennai, Tamil Nadu - 600037 | Contact - 044-40114443",
    googleMapLink: "https://maps.app.goo.gl/hWTDbGtjTnEi5YNg6",
    images: [
      "https://d21gjxs9m3o5hx.cloudfront.net/uploadvenueimages/1748864777703-filename0.jpg"
       ]
  },
  {
    companyName: "PlayAll",
    venueName: "PlayAll HICAS Coimbatore",
    numberOfCourts: "a", // You can adjust this based on actual number
    courtType: "6-Vs-6",
    city: "Coimbatore",
    address: "Hindustan College of Arts & Science, Avinashi Rd, behind Nava India, Udayampalayam, Coimbatore, Tamil Nadu 641028 | Contact - 044-40114355",
    googleMapLink: "https://maps.app.goo.gl/W66hgWjS37q92m9p8",
    images: [
      "https://d21gjxs9m3o5hx.cloudfront.net/uploadvenueimages/1740379097966-filename0.jpg"
    ],
  },
  {
    companyName: "PlayAll",
    venueName: "PlayAll APS Pitampura",
    numberOfCourts: "a", // Update this number based on actual court count if needed
    courtType: "6-Vs-6",
    city: "New Delhi",
    address: "Abhinav School, Pitampura Marg, Block CU, Ranikhet, Pitampura, New Delhi, Delhi, 110034 | Contact - 01141170771",
    googleMapLink: "https://maps.app.goo.gl/cuahSyZtBxvvxaFV7",
    images: [
      "https://d21gjxs9m3o5hx.cloudfront.net/allvenues/Abhinav+School+Pitampura/WhatsApp+Image+2025-02-12+at+15.22.11+(3).jpeg",
      "https://d21gjxs9m3o5hx.cloudfront.net/allvenues/Abhinav+School+Pitampura/WhatsApp+Image+2025-02-12+at+15.22.11+(2).jpeg",
      "https://d21gjxs9m3o5hx.cloudfront.net/allvenues/Abhinav+School+Pitampura/WhatsApp+Image+2025-02-12+at+15.22.11+(1).jpeg",
      "https://d21gjxs9m3o5hx.cloudfront.net/allvenues/Abhinav+School+Pitampura/WhatsApp+Image+2025-02-12+at+15.22.11.jpeg"
    ],
  },
  {
    companyName: "PlayAll",
    venueName: "PlayAll Gaur City 1",
    numberOfCourts: "a", // Update if there are more
    courtType: "7-Vs-7",
    city: "Greater Noida",
    address: "Gaur City Sports Complex, E Block, Gaur City 1, Sector 4, Greater Noida, Uttar Pradesh 201009 | Contact - 011-411-87822",
    googleMapLink: "https://goo.gl/maps/XRjs1h6FZjYUoPtv7",
    images: [
      "images/gallery/gaurs_futsal_0.png",
      "images/gallery/gaurs_futsal_1.png",
      "images/gallery/gaurs_futsal_2.png"
    ],
  },
  {
    companyName: "Play All",
    venueName: "PlayAll Faridabad 86",
    numberOfCourts: "a", // Can be updated if needed
    courtType: "6-Vs-6",
    city: "Faridabad",
    address:
      "Near Sai Mandir, Sector 86, Faridabad, Haryana 121002 | Contact - 01141187780",
    googleMapLink: "https://maps.app.goo.gl/NXWdbBZ4TipBSeUh9",
    images: [
      "images/gallery/faridabad_futsal_0.png",
      "images/gallery/faridabad_futsal_1.png",
      "images/gallery/faridabad_futsal_2.png",
      "images/gallery/faridabad_futsal_3.png",
      "images/gallery/faridabad_futsal_4.png"
    ],
  },
  {
    companyName: "PlayAll",
    venueName: "PlayAll Gurgaon 62",
    numberOfCourts: "a", // Update if needed
    courtType: "7-Vs-7",
    city: "Gurgaon",
    address: "CRPF Road, Opposite Heritage School, Sector 62, Gurgaon | Contact - 01141179906",
    googleMapLink: "https://goo.gl/maps/ehmfU6Qtyw82",
    images: [
      "images/gallery/gurgaon_futsal_0.png",
      "images/gallery/gurgaon_futsal_1.png",
      "images/gallery/gurgaon_futsal_2.png",
      "images/gallery/gurgaon_futsal_3.png"
    ],
  },
  {
    companyName: "Play All",
    venueName: "PlayAll KPS Alaknanda",
    numberOfCourts: "a", // Update if you have more courts
    courtType: "6-Vs-6",
    city: "Delhi",
    address: "Kalka Public School, Kalka Public School Rd, Alaknanda, New Delhi, Delhi | Contact - 011-411-87784",
    googleMapLink: "https://goo.gl/maps/hdrrcpF2sTk5EvCE6",
    images: [
      "images/gallery/kalka_public_school_1.png",
      "images/gallery/kalka_public_school_2.png",
      "images/gallery/kalka_public_school_3.png"
    ],
  },
  {
    companyName: "Play All",
    venueName: "PlayAll Orbit Mall",
    numberOfCourts: "a", // Update if needed
    courtType: "7-Vs-7",
    city: "Jaipur",
    address: "Civil Lines Metro Station, Orbit Mall, Ajmer Rd, Madrampur, Civil Lines, Jaipur, Rajasthan 302006 | Contact - 011-411-86654",
    googleMapLink: "https://goo.gl/maps/4VAo7j8ZzX9rBojQ9",
    images: [
      "images/gallery/orbitMall_futsal_0.png",
      "images/gallery/orbitMall_futsal_1.png",
      "images/gallery/orbitMall_futsal_2.png",
      "images/gallery/orbitMall_futsal_3.png"
    ],
  }


]
const mainSection = (
  <>
    <main>
      {futsalVenueList.map((item, index) => {
        return (
          <section class='partnersec ' key={`effejkbjdfb${index}`}>
            <div class='container'>
              <div class='innerbx pb-5'>
                {index % 2 === 0 ?
                  <div class='contentarea '>
                    <Zoom>  <h4 >{item.companyName}</h4>
                      <h2 >{item.venueName}</h2>
                      <p>With {item.numberOfCourts} {item.courtType} approved 50 mm <b>Futsal Turf </b>, Play All is one of the best <b>Football Ground</b> in {item.city}. With Amenities like Ample Parking, Shower, Cafeteria, and Sports Shop, we ensure that your Football experience is hassel free and awesome. </p>

                    </Zoom>

                    <span class='address'>
                      Address - {item.address}
                    </span>
                    <div class='btarea mb-3'>


                      <a href={item.googleMapLink} class='btwhite1'
                        target="_blank"
                        rel="noreferrer"
                      >

                        <svg width='34' height='41'>
                          <use href='#googleMap'></use>
                        </svg>
                        <Zoom >Directions</Zoom>
                      </a>
                    </div>


                    <div class='sportsavailble'>
                      <Zoom>Book via</Zoom>
                      <div class='divider'></div>
                      <a
                        href='https://play.google.com/store/apps/details?id=com.playallrn'
                        class='btorng'
                        style={{ background: "#000000" }}
                        target="_blank"
                        rel="noreferrer"
                      >
                        {" "}
                        <img alt='' src='images/playStore.png' style={{ height: "120px" }} />
                      </a>


                      <div class='divider'></div>
                      <a
                        class='btorng justify-content-center'
                        href='https://apps.apple.com/us/app/play-all/id6480510323'
                        style={{ background: "#000000" }}
                        rel="noreferrer"
                        target="_blank"
                      >
                        <img src='images/appStore.png' alt='' style={{ height: "120px" }} />
                      </a>
                    </div>


                  </div>
                  :
                  <div class=' rightbx startplayarea1 d-flex justify-content-center'>
                    <div class='startplaybox'>
                      <Fade >
                        <Carousel showThumbs={false} showIndicators={false} showStatus={false} autoPlay={true} infiniteLoop={true} interval={1400} swipeable={true} emulateTouch={true}>
                          {item.images.map((insideItem, index) => {
                            return (
                              <img src={insideItem} alt='pickleball in jaipur' key={`ewfhewhklkwebkj${index}`} />
                            )
                          })}

                        </Carousel></Fade>
                    </div>
                  </div>
                }
                {index % 2 === 0 ?
                  <div class=' rightbx startplayarea1 d-flex justify-content-center'>
                    <div class='startplaybox'>
                      <Fade >
                        <Carousel showThumbs={false} showIndicators={false} showStatus={false} autoPlay={true} infiniteLoop={true} interval={1400} swipeable={true} emulateTouch={true}>
                          {item.images.map((insideItem, index) => {
                            return (
                              <img src={insideItem} alt='pickleball in jaipur' key={`ewfhewhklkwebkj${index}`} />
                            )
                          })}

                        </Carousel></Fade>
                    </div>
                  </div>
                  :
                  <div class='contentarea '>
                    <Zoom>  <h4 >{item.companyName}</h4>
                      <h2 >{item.venueName}</h2>
                      <p>With {item.numberOfCourts} {item.courtType} approved 50 mm <b>Futsal Turf </b>, Play All is one of the best <b>Football Ground</b> in {item.city}. With Amenities like Ample Parking, Shower, Cafeteria, and Sports Shop, we ensure that your Football experience is hassel free and awesome. </p>

                    </Zoom>

                    <span class='address'>
                      Address - {item.address}
                    </span>
                    <div class='btarea mb-3'>


                      <a href={item.googleMapLink} class='btwhite1'
                        target="_blank"
                        rel="noreferrer"
                      >

                        <svg width='34' height='41'>
                          <use href='#googleMap'></use>
                        </svg>
                        <Zoom >Directions</Zoom>
                      </a>
                    </div>


                    <div class='sportsavailble'>
                      <Zoom>Book via</Zoom>
                      <div class='divider'></div>
                      <a
                        href='https://play.google.com/store/apps/details?id=com.playallrn'
                        class='btorng'
                        style={{ background: "#000000" }}
                        target="_blank"
                        rel="noreferrer"
                      >
                        {" "}
                        <img alt='' src='images/playStore.png' style={{ height: "120px" }} />
                      </a>


                      <div class='divider'></div>
                      <a
                        class='btorng justify-content-center'
                        href='https://apps.apple.com/us/app/play-all/id6480510323'
                        style={{ background: "#000000" }}
                        rel="noreferrer"
                        target="_blank"
                      >
                        <img src='images/appStore.png' alt='' style={{ height: "120px" }} />
                      </a>
                    </div>


                  </div>

                }

              </div>
            </div>
          </section>
        )
      })}
 
      <section class=' techsection footballdeco'>
        <div class='container'>
          <div class='headarea'>
            <h4 class=' sectiontitle '>
              PlayAll
            </h4>
            <Fade bottom cascade><h2 class=' sectionhead '>
              One-Stop-Destination for Futsal Lovers
            </h2></Fade>
          </div>
          <div class='techarea sportsarea'>
            <div class='sportsbox '>
              <div class='iconarea'>
                <svg viewBox="0 0 55.558 47.814">
                  <use href="#data"></use>
                </svg>
              </div>
              <Zoom><h4 >Pay & Play | Memberships</h4></Zoom>
              <span>BOOK YOUR TURF IN ADVANCE, SIT BACK & RELAX!</span>
            </div>
            <div class='sportsbox '>
              <div class='iconarea'>
                <svg>
                  <use href='#football '></use>
                </svg>
              </div>
              <Zoom><h4 >Coaching</h4></Zoom>
              <span>
                CURRICULUM-DRIVEN COACHING BY PROFESSIONAL COACHES.

              </span>
            </div>
            <div class='sportsbox '>
              <div class='iconarea'>
                <svg viewBox='0 0 55.558 47.814'>
                  <use href='#stadium'></use>
                </svg>
              </div>
              <Zoom><h4 >Best-in-class Infra</h4></Zoom>
              <span>
                FIFA APPROVED TURF, INTERNATIONAL LIGHTING, 20 FT HEIGHT
              </span>
            </div>

          </div>
        </div>
      </section>

    </main>
  </>
);

const Futsal = () => {
  return (
    <>

      <Helmet>
        <title>Futsal - Football Ground, Futsal Turf, and mini football Ground</title>
        <meta name="description" content="Play all offers best Futsal Turf and Football Ground. In Noida we have 2 football ground near sector 11. In Faridabad we have 1 football ground near sector 86. In Gurgoan we have 1 football ground near sector 62." />
      </Helmet>
      <div style={{ overflowY: "scroll", height: "calc(100vh)" }}>
        {topSectionData}
        <div class='headbanner membershipbg' data-aos='fade'>
          <div class='container '>
            <NavSection current={"football-ground"} />
            {contentSection}
          </div>
        </div>
        {mainSection}
        {footerSection}
      </div>
    </>
  );
};

export default Futsal;
